'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.departingFilter = departingFilter;
var angular = require('angular');

/*@ngInject*/
function departingFilter() {
  return function (input, query) {
    input = input || '';
    var out = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var value = _step.value;

        if (value.departing == query) {
          out.push(value);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return out;
  };
}

exports.default = angular.module('fiapiApp.departing', []).filter('departing', departingFilter).name;


// WEBPACK FOOTER //
// ./client/filters/departing/departing.filter.js